export default __webpack_public_path__ + "static/media/Snd3.86b00c01.mp3";